/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Published_Future1Inputs */

const vi_cmspost_error_published_future1 = /** @type {(inputs: Cmspost_Error_Published_Future1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày đăng không được ở tương lai (website không hẹn giờ đăng).`)
};

/**

* @param {Cmspost_Error_Published_Future1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_published_future1 = /** @type {((inputs?: Cmspost_Error_Published_Future1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Published_Future1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_published_future1(inputs)
});
export { cmspost_error_published_future1 as "cmsPost_error_published_future" }